import { createAction } from '@ngrx/store';

export const ClearStateAndStorage = createAction('[Session Storage] Clear session storage');
